/**
 * Abre um Content do SubMenu sem alterar o empreenderUI.
 * Usa toggle() apenas quando o painel ainda não está aberto,
 * evitando fechar o painel em re-renders / sync de rota.
 */
export const ensureContentOpen = (id, { state, toggle }) => {
	if (!id || !toggle) return;
	if (state?.[id]) return;
	toggle(id);
};
